<script>
const { VUE_APP_API_HOST } = process.env

export default {
  methods: {
    getLabels() {
      return this.$http.get(`${VUE_APP_API_HOST}/labels`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then(
        (res) => res.body.labels || [],
        (err) => err
      )
    },

    newLabel(label) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/labels/`, label, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    },

    updateLabel(label) {
      return this.$http
        .put(`${VUE_APP_API_HOST}/labels/${label.id}`, label, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    },

    deleteLabel(id) {
      return this.$http
        .delete(`${VUE_APP_API_HOST}/labels/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    },

    setPostLabels({ id, labels, all }) {
      return this.$http
        .put(`${VUE_APP_API_HOST}/posts/${id}/labels`, { labels, all }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    }
  }
}
</script>
